import { STATES } from './constants';

const createResourceStatusReducer = (baseActions, resetActions) => {
  const success = []
    .concat(baseActions)
    .map(action => `${action}_${STATES.SUCCESS}`);

  const failure = []
    .concat(baseActions)
    .map(action => `${action}_${STATES.FAILURE}`);

  const loading = []
    .concat(baseActions)
    .map(action => `${action}_${STATES.REQUEST}`);

  const reset = [].concat(resetActions);

  return (state = STATES.PENDING, action = {}) => {
    if (success.includes(action.type)) {
      return STATES.SUCCESS;
    }

    if (failure.includes(action.type)) {
      return STATES.FAILURE;
    }

    if (loading.includes(action.type)) {
      return STATES.LOADING;
    }

    if (reset.includes(action.type)) {
      return STATES.PENDING;
    }

    return state;
  };
};

export default createResourceStatusReducer;
